import React from 'react';
import { FaDiscord } from 'react-icons/fa';
import { loginWithDiscord } from '../services/api';
import '../styles/Login.css';

function Login() {
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔗 Link Collector</h1>
          <p>Dashboard</p>
        </div>

        <div className="login-content">
          <h2>Welcome Back!</h2>
          <p>Sign in with your Discord account to access the dashboard</p>

          <button onClick={loginWithDiscord} className="discord-login-btn">
            <FaDiscord size={24} />
            Login with Discord
          </button>

          <div className="login-info">
            <p>✅ Secure Discord OAuth2 authentication</p>
            <p>✅ View and manage collected links</p>
            <p>✅ Configure bot commands</p>
            <p>✅ Manage watched channels</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
